import { Debug, Utils, ReduxSagaRequest, Request } from "@hlibs/index";
import Language from "@app/language";

export const SignUp = async (payload, callback, reduxModule) => {
  const stateKey = "SignUp";

  if (Utils.checkNullOrEmpty(payload))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err2,
      stateKey
    );

  try {
    const response = await Request.post("/account/signup", payload);

    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (
      Utils.checkKeyExists(data, ["id"]) ||
      Utils.checkKeyExists(data, ["result"])
    ) {
      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const PwChange = async (payload, callback, reduxModule) => {
  const stateKey = "PwChange";

  if (Utils.checkNullOrEmpty(payload))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err2,
      stateKey
    );

  try {
    const response = await Request.post("/account/password/change", payload);

    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (
      Utils.checkKeyExists(data, ["id"]) ||
      Utils.checkKeyExists(data, ["result"])
    ) {
      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Login = async (payload, callback, reduxModule) => {
  const stateKey = "Login";

  if (Utils.checkNullOrEmpty(payload, payload.id, payload.pw))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );

  try {
    const response = await Request.post("/account/login", payload);

    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (Utils.checkKeyExists(data, ["id"])) {
      reduxModule.set(data, "user");

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const TokenCheck = async (callback, reduxModule) => {
  const stateKey = "TokenCheck";

  try {
    const response = await Request.post("/account/check");

    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error || data?.error?.status_code == 401) {
      reduxModule.set(true, "checked");

      return ReduxSagaRequest.makeResult.success(null, stateKey);
    } else if (Utils.checkKeyExists(data, ["id"])) {
      reduxModule.setMultiple({
        checked: true,
        user: data,
      });

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }

    reduxModule.set(true, "checked");
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Logout = async (callback, reduxModule) => {
  const stateKey = "Logout";

  try {
    const response = await Request.post("/account/logout");

    const { data } = response;

    if (callback) callback(data, response);

    if (
      data?.error?.status_code == 401 ||
      Utils.checkKeyExists(data, ["token"]) ||
      (data && Object.keys(data).length < 1)
    ) {
      reduxModule.set(null, "user");

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Reset = async (payload, callback, reduxModule) => {
  const stateKey = "Reset";

  if (!payload || payload.length < 1)
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err2,
      stateKey
    );

  try {
    const response = await Request.post("/account/password/reset", {
      email: payload.email,
    });

    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (data) {
      let user = reduxModule.user;

      if (user && data && Object.keys(data).length > 0) {
        user = Utils.mergeObject(user, data);
      }

      reduxModule.set(user, "user");

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Update = async (payload, callback, reduxModule) => {
  const stateKey = "Update";

  if (!payload || payload.length < 1)
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err2,
      stateKey
    );

  try {
    const response = await Request.post("/account/update", {
      data: {
        email: payload.email,
      },
      user_id: payload.user_id,
    });

    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (data) {
      let user = reduxModule.user;

      if (user && data && Object.keys(data).length > 0) {
        user = Utils.mergeObject(user, data);
      }

      reduxModule.set(user, "user");

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Withdraw = async (callback, reduxModule) => {
  const stateKey = "Withdraw";

  try {
    const response = await Request.post("/account/withdraw");

    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (data) {
      reduxModule.reset();

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};
